import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { QueryKeys } from "../queryKeys";
import { BasePagingResponse } from "../_types";

export type GetEneryaReconciliationListRequest = {
  date?: string;
  page?: number;
  size?: number;
  // Add other fields as needed based on the actual API
  // For example, from the existing EneryaListingPageFormSchema:
  startDate?: string;
  endDate?: string;
  searchText?: string;
  merchantId?: number;
  orderBy?: string;
  filters?: Array<{
    field: string;
    values: string[];
    operationType: number;
    valueType: number;
  }>;
};

export type GetEneryaReconciliationListResponse = BasePagingResponse<Array<any>>;

async function getEneryaReconciliationList(   
  data: GetEneryaReconciliationListRequest
): Promise<any> {
  try {
    const response = (await axiosInstance.post("/EneryaReconciliation/List", data)).data;
    return response;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetEneryaReconciliationList() {
  return useMutation<GetEneryaReconciliationListResponse, Error, GetEneryaReconciliationListRequest>((variables) =>
    getEneryaReconciliationList(variables)
  );
}
